<template>
  <transition name="fade">
    <div
      v-if="message"
      :id="errorId"
      class="field-error"
      role="alert"
      aria-live="polite"
    >
      <svg class="error-icon" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
      </svg>
      <span>{{ message }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'FieldError',
  props: {
    message: {
      type: String,
      default: ''
    },
    errorId: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.field-error {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  color: #DC2626;
  font-size: 14px;
  line-height: 1.4;
}

.error-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
